import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class CoalDepositTerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.COAL_DEPOSIT;
}

export default CoalDepositTerrainTileEntity;
